import { Box } from "@mui/material";
import React from "react";
import QcVerifyConfrmApprvFilter from "../../../../components/QcVerifyConfrmApprvFilter/QcVerifyConfrmApprvFilter";
import QcVerifiedConfirmApprovedTable from "../../../../components/QcVerifiedConfirmApprovedTable/QcVerifiedConfirmApprovedTable";
import styles from "../../../../styles/pages/user/managerdashboard/verifiedvideosconfirmed.module.scss";
import { FetchQCVideos } from "../../../../api/functions/video.api";
import { getStartEndDateTwo } from "../../../../lib/functions/utils.lib";
import { useState } from "react";
import { useAppSelector } from "../../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../../hooks/useAppDispatch";
import { useQuery } from "react-query";
import { useEffect } from "react";
import {
  setManagerId,
  setPurchased,
  setUserId,
  setMonth,
  setYear,
  setSubmitPlace,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
} from "../../../../redux-toolkit/slices/qc/qc.verified.approved.approved.slice";
import ApiLoader from "../../../../components/Loaders/ApiLoader";

const QcVerifiedConfirmConfirmTab = () => {
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const dispatch = useAppDispatch();

  const {
    manager_id,
    user_id,
    month,
    year,
    submit_place,
    has_note,
    unreachable_submitter,
    purchased,
    hasMessage,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
  } = useAppSelector((s) => s.qcVerifiedApprovedApprovedSlice);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(["qc_verified_approved_approved"], async () =>
    FetchQCVideos({
      page,
      manager_id,
      manager_decision: 1,
      quality_team_decision: 1,
      user_id,
      from: month || year ? getStartEndDateTwo(month, year).start_date : from,
      to: month || year ? getStartEndDateTwo(month, year).end_date : to,
      country: submit_place,
      has_note,
      unreachable_submitter,
      purchased,
      hasMessage,
      people_appearing,
      person_who_filmed,
      submit_place: submit_other_website,
      aggrement_with_another_company,
    })
  );

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };
  useEffect(() => {
    if (fetchTrigger) {
      refetchAgain();
    }
  }, [fetchTrigger]);
  // console.log("data--------------", data?.data);

  const filterRefetch = () => {
    handleTriggreFetch();
    setOpenFilterModal(false);
    setPage(1);
  };

  const filtersReset = () => {
    dispatch(setManagerId(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setSubmitPlace(null));
    dispatch(setHasNote(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPurchased(null));
    dispatch(setHasMessage(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    setPage(1);
    handleTriggreFetch();
  };

  const [filterActive, setFilterActive] = useState(false);
  useEffect(() => {
    if (
      manager_id ||
      user_id ||
      month ||
      year ||
      submit_place ||
      has_note ||
      unreachable_submitter ||
      purchased ||
      hasMessage ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    manager_id,
    user_id,
    month,
    year,
    submit_place,
    has_note,
    unreachable_submitter,
    purchased,
    hasMessage,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
  ]);
  return (
    <div>
      <Box className={styles.single_rreview_tab}>
        <ApiLoader loading={isLoading} />
        <Box className={styles.reviewd_filter_wrap}>
          <QcVerifyConfrmApprvFilter
            handleTriggreFetch={handleTriggreFetch}
            filterActive={filterActive}
            handleClearFilterModal={filtersReset}
            filtersReset={filtersReset}
            filterRefetch={filterRefetch}
            openFilterModal={openFilterModal}
            setOpenFilterModal={setOpenFilterModal}
            datas={data?.data}
          />
        </Box>

        <Box className={styles.approved_videos_table_wrap}>
          <QcVerifiedConfirmApprovedTable
            datas={data?.data}
            page={page}
            handlePageChange={handlePageChange}
            filterActive={filterActive}
            handleTriggreFetch={handleTriggreFetch}
            handleClearFilterModal={filtersReset}
            filtersReset={filtersReset}
            loading={isLoading}
          />
        </Box>
      </Box>
    </div>
  );
};

export default QcVerifiedConfirmConfirmTab;
